import leDialog from './index.vue'
leDialog.install = function (Vue) {
  Vue.component(leDialog.name, leDialog)
}
export default leDialog
